import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../utils';

const markerVariants = cva('w-1 rounded', {
  variants: {
    variant: {
      default: 'bg-border-default',

      neutral: 'bg-neutral',
      brown: 'bg-brown',
      citrine: 'bg-citrine',
      amber: 'bg-amber',
      orange: 'bg-orange',
      lime: 'bg-lime',
      green: 'bg-green',
      grass: 'bg-grass',
      sky: 'bg-sky',
      emerald: 'bg-emerald',
      blue: 'bg-blue',
      purple: 'bg-purple',
      fuchsia: 'bg-fuchsia',
      red: 'bg-red',
      magenta: 'bg-magenta',

      success: 'bg-success',
      warning: 'bg-warning',
      critical: 'bg-critical',
    },
    border: {
      true: 'border',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
  compoundVariants: [
    { variant: 'default', border: true, class: 'border-border-default bg-background' },

    { variant: 'neutral', border: true, class: 'border-neutral bg-neutral/10' },
    { variant: 'brown', border: true, class: 'border-brown bg-brown/10' },
    { variant: 'citrine', border: true, class: 'border-citrine bg-citrine/10' },
    { variant: 'amber', border: true, class: 'border-amber bg-amber/10' },
    { variant: 'orange', border: true, class: 'border-orange bg-orange/10' },
    { variant: 'lime', border: true, class: 'border-lime bg-lime/10' },
    { variant: 'green', border: true, class: 'border-green bg-green/10' },
    { variant: 'grass', border: true, class: 'border-grass bg-grass/10' },
    { variant: 'sky', border: true, class: 'border-sky bg-sky/10' },
    { variant: 'emerald', border: true, class: 'border-emerald bg-emerald/10' },
    { variant: 'blue', border: true, class: 'border-blue bg-blue/10' },
    { variant: 'purple', border: true, class: 'border-purple bg-purple/10' },
    { variant: 'fuchsia', border: true, class: 'border-fuchsia bg-fuchsia/10' },
    { variant: 'red', border: true, class: 'border-red bg-red/10' },

    { variant: 'magenta', border: true, class: 'border-magenta bg-magenta/10' },
    { variant: 'success', border: true, class: 'border-success bg-success/10' },
    { variant: 'warning', border: true, class: 'border-warning bg-warning/10' },
    { variant: 'critical', border: true, class: 'border-critical bg-critical/10' },
  ],
});

export interface MarkerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof markerVariants> {}

export type MarkerColor = MarkerProps['variant'];

function Marker({ className, variant, border, ...props }: MarkerProps) {
  return <div className={cn(markerVariants({ variant, border }), className)} {...props} />;
}

export { markerVariants, Marker };
